<script>
   /*************************************************************/
   /* Root component for the application                        */
   /*************************************************************/

   import App from '../../shared/components/MainApp.svelte';
   import TrainAppContainer from './tab_train/AppContainer.svelte';
   import PredictAppContainer from './tab_new/AppContainer.svelte';
   import WASM from '../../shared/wasm/dist/pca_wasm.js';

   const containers = [
      {name: 'Train', container: TrainAppContainer},
      {name: 'Project', container: PredictAppContainer},
   ]
</script>

<App appTitle="PCA" appShortTitle="PCA" isBeta={false} appSlogan="Principal component analysis" {WASM} {containers}>
   <div slot="footer">
      <p>Current release: <span>1.0.1</span>
      Feedback: <a class="paper-link" href="mailto:help@mda.tools?subject=PCA app">help@mda.tools</a>
      Tutorial:
      <a class="paper-link" href="Wines.zip" download>dataset</a>
      | <a href="https://www.youtube.com/playlist?list=PLep7KM9cEyFnCpcLEwI63Zj1YJZrVL0WH">video lessons</a>
      </p>
   </div>

   <h2>Principal Component Analysis</h2>
   <p>Authors: <em>Sergey Kucheryavskiy, Oxana Rodionova, Alexey Pomerantsev</em></p>
   <p>
      Interactive web-application for creating and using PCA models for data exploration
      directly in your browser. The app does not send any information to the server,
      all calculations are done locally on your device.
   </p>
   <p>Check out YouTube <a href="https://www.youtube.com/playlist?list=PLep7KM9cEyFnCpcLEwI63Zj1YJZrVL0WH">video-lessons</a>
   <h3>v. 1.0.1</h3>
   <p class="release-info">released 12/11/2024</p>
   <ul>
      <li>Initial release.</li>
   </ul>
</App>

